import * as UI from './view-label.styled'

export interface ViewLabelProps extends React.PropsWithChildren, React.HTMLAttributes<HTMLDivElement> {}

export const ViewLabel = ({children, ...props}: ViewLabelProps) => {
  return <UI.Component {...props}>{children}</UI.Component>
}
